document.addEventListener("DOMContentLoaded", function () {

  const params = new URLSearchParams(window.location.search);

  if (params.get("openRewards") !== "1") return;

  const interval = setInterval(() => {

    const button = document.getElementById('launcher-wrapper');

    if (button) {
      clearInterval(interval);
      button.click();
    }

  }, 500);

});